import { graphql } from "gql";

const ADMIN_PREVIEW_DISTRIBUTION_GROUP_MEMBERSHIP_QUERY = graphql(`
  query adminPreviewDistributionGroupMembership(
    $input: AdminPreviewDistributionGroupMembershipInput!
  ) {
    adminPreviewDistributionGroupMembership(input: $input) {
      userIdList
      emailUserIdList
    }
  }
`);

export default ADMIN_PREVIEW_DISTRIBUTION_GROUP_MEMBERSHIP_QUERY;
